import { Outlet } from "react-router-dom";

const CommunityList = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default CommunityList;